import { cn } from "web-design-system";

export function ArticleThumbnail({
  label,
  className,
  src,
}: {
  label: string;
  className?: string;
  src: string;
}) {
  return (
    <img
      src={src}
      alt={label}
      className={cn(
        "h-54 w-full object-cover rounded-xl overflow-hidden",
        className
      )}
    />
  );
}
